import i18next from "i18next";
import { NOTIFICATIONS_SECTION_ID, NOTIFICATIONS_SECTION_ORDER } from "@/src/notifications/constants/notifications.constants";
import { NotificationsSection } from "@/src/notifications/sections/notifications.section";
import { registerSettingsSection } from "@/src/settings/settings-sections.registry";

let bootstrapped = false;

function bootstrap(): void {
	if (bootstrapped) return;
	bootstrapped = true;

	registerSettingsSection({
		id: NOTIFICATIONS_SECTION_ID,
		order: NOTIFICATIONS_SECTION_ORDER,
		title: i18next.t("notifications:section.title"),
		description: i18next.t("notifications:section.description"),
		component: NotificationsSection,
	});
}

bootstrap();
